module.exports = __webpack_public_path__ + "assets/images/skincolor-03.82f30d40fe35a4b943e693dda078d666.svg";